// import { useRef, useState, useEffect } from "react"
import { connect } from "react-redux"

import { EntityInput } from "../Entity/EntityInput";

import "styles/components/popup.sass"

export const ENTREPRENEUR_STAMP_KEY = "organisation_stamp"


let UserStamp: any = function UserStamp(inputState: any) {
    const [value, setValue] = inputState.inputState;
    return <EntityInput
        entity={{value, type: "Фото", addWatermark: false}}
        updateEntity={(value: string) => {
            setValue(value)
        }}
        setImageStringTag={false}
        maxImageWidth="120px"
    />
}

UserStamp = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
      $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(UserStamp)

export default UserStamp
